import React, { Component } from 'react';
import Header from './HeaderComponent';
import Home from './HomeComponent';
import Services from './ServicesComponent';
import Footer from './FooterComponent';
import { SERVICES } from '../shared/services';
import { Switch, Route, Redirect} from 'react-router-dom';

class Main extends Component {
    constructor(props) {
        super(props);  
        this.state = {
            isModalOpen: false,    
            services: SERVICES       
       };
       this.toggleModal = this.toggleModal.bind(this);
    }

    toggleModal() {
        this.setState({
         isModalOpen: !this.state.isModalOpen
        });
    }

    handleSubmit(values) {
        alert("Current state is: " + JSON.stringify(values));
        this.toggleModal();        
    }

    render() {
        const HomePage = () => {
            return (
                <Home />
            );
        }
        
        return (
            <div>
                <Header />
                <Switch>
                    <Route path='/home' component={HomePage} />
                    <Route exact path='/services' render={() => <Services services={this.state.services} />} />
                    <Redirect to='/home' />                   
                </Switch>
                <Footer />
            </div>
        );
    };
}

export default Main;